import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export interface GetStadiumFollowersParams {
  stadium_id: number;
  page: number;
}

export interface StadiumFollower {
  stadium_id: number;
  users: {
    id: number;
    name: string;
    image: string;
  };
}

export interface GetStadiumFollowersResponse {
  data: StadiumFollower[];
  meta: {
    current_page: number;
    last_page: number;
    total: number;
  };
}

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<GetStadiumFollowersResponse, GetStadiumFollowersParams>({
    query: (params) => ({
      url: `/v4/pitch-owner/stadiums/${params.stadium_id}/followers?page=${params.page}`,
      method: 'GET',
    }),
  });
